import React, { useRef } from "react";
import { TableEdit, TableEditProps } from "collections/Table";
import { MAX_SEARCH_CHARS } from "Constants";
import { PolyIcon } from "elements";
import { useTranslation } from "utilities/i18n";
import { sanitizeSearchInput } from "utilities/search";

type DeviceInfoTableSearchProps = {
  onSearch: (searchTerm: string | undefined) => void;
  searchPlaceholder?: string;
};

export const DeviceInfoTableSearch: React.FC<DeviceInfoTableSearchProps> = ({
  onSearch,
  searchPlaceholder
}) => {
  const { t } = useTranslation();

  const input = useRef<HTMLInputElement>(null);

  const clearSearch = () => {
    input.current!.value = "";
    onSearch("");
  };

  const searchTermPresent: boolean = Boolean(input.current?.value.length);

  return (
    <div className="table-search">
      <PolyIcon icon="search" />
      <input
        type="text"
        ref={input}
        placeholder={searchPlaceholder ?? t("SEARCH_TABLE")}
        aria-label={searchPlaceholder ?? t("SEARCH_TABLE")}
        data-testid="search-table"
        onChange={e => onSearch(sanitizeSearchInput(e.target.value))}
        maxLength={MAX_SEARCH_CHARS}
      />
      {searchTermPresent && (
        <PolyIcon icon="clear_x" onClick={clearSearch} className="clear" />
      )}
    </div>
  );
};

export const DeviceInfoSearchEdit: React.FC<{
  search?: DeviceInfoTableSearchProps;
  edit?: TableEditProps;
}> = ({ search, edit }) => {
  return (
    <div className="table-search-edit">
      {search && <DeviceInfoTableSearch {...search} />}
      {edit && <TableEdit {...edit} />}
    </div>
  );
};
